


























import { computed, defineComponent, onBeforeUnmount, ref } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import useSystemSettings from "@/hooks/useSystemSettings";
import config from "@/config";
import { MoreMenuType, SideBarPosition } from "@/const";
import BaseIconButton from "@/components/BaseIconButton";
import NavigationMore from "@/components/MainNavigationBar/components/NavigationMore";
import SiteLogo from "@/components/SiteLogo";

export default defineComponent({
  name: "MainStickyHeader",
  components: {
    NavigationMore,
    BaseIconButton,
    SiteLogo,
    HomeFeedFilters: () => import("@/views/PageHome/components/HomeFeedFilters"),
  },
  setup(_, { root }) {
    const { frontendConfig } = useSystemSettings();
    const { authUser } = useAuthUser();
    const showMore = ref(false);

    const isMenuPage = computed(() => frontendConfig.value.menuType === MoreMenuType.PAGE);

    const onMenuClick = () => {
      if (!isMenuPage.value) {
        showMore.value = !showMore.value;
      }
    };

    const to = computed(() => (isMenuPage.value ? { name: "more" } : undefined));
    const isLeftPosition = computed(() => frontendConfig.value.sideBarPosition === SideBarPosition.LEFT);
    const bordered = computed(() => !["/", "/feed", "/discover", "/discover/feed"].includes(root.$route.path));
    const isHomePage = computed(() => root.$route.name === "home");
    const showHomeFilters = computed(() => isHomePage.value && (config.featureTags || !config.featureHideLocalization));

    document.documentElement.style.setProperty("--safe-top-position-nav", "56px");
    onBeforeUnmount(() => {
      document.documentElement.style.setProperty("--safe-top-position-nav", "0px");
    });
    return { to, authUser, showMore, isLeftPosition, bordered, isHomePage, showHomeFilters, onMenuClick };
  },
});
